module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.user) ? _c('section', {
    staticClass: "top_section"
  }, [_c('div', {
    staticClass: "info_nav"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "user_name_wrap"
  }, [_c('div', {
    staticClass: "inner-flex"
  }, [(_vm.user.personal.name || _vm.user.personal.surname) ? _c('h1', [_c('span', [_vm._v(_vm._s(_vm.user.personal.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.personal.surname))])]) : _c('div', {
    staticClass: "add_name",
    on: {
      "click": _vm.showChangeName
    }
  }, [_vm._v("Укажите свое имя")])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrap"
  }, [_c('ul', {
    staticClass: "nav wd"
  }, [_c('li', [_c('router-link', {
    staticClass: "tickets",
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M20 6v2.537A4.003 4.003 0 0 0 18 12c0 1.477.805 2.771 2 3.463V18H4v-2.537A4 4 0 0 0 6 12a4 4 0 0 0-2-3.463V6h16zm0-2H4a2 2 0 0 0-2 2v4a2 2 0 1 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 1 1 0-4V6a2 2 0 0 0-2-2z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("top_section.navigation.tickets_and_bar")))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "profile",
    attrs: {
      "to": "/profile"
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 5c-2.75 0-5 2.25-5 5 0 1.516.707 2.863 1.781 3.781A7.005 7.005 0 0 0 5 20h2c0-2.773 2.227-5 5-5s5 2.227 5 5h2c0-2.7-1.531-5.05-3.781-6.219C16.293 12.863 17 11.516 17 10c0-2.75-2.25-5-5-5zm0 2c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("top_section.navigation.profile")))])])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "support",
    attrs: {
      "href": "https://multiplex.ua/faq#support",
      "id": "support"
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm1 11v2h-2v-2h2zm-1-8c.897 0 1.705.363 2.229.938.523.574.771 1.319.771 2.062 0 1.286-.73 2.18-1.244 2.773-.515.594-.756.892-.756 1.227h-2c0-1.202.759-1.978 1.244-2.537.485-.56.756-.898.756-1.463 0-.296-.1-.551-.25-.717C12.6 9.118 12.406 9 12 9c-.396 0-.588.12-.744.293-.156.174-.256.44-.256.707H9c0-.732.25-1.467.768-2.043C10.286 7.381 11.093 7 12 7z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("top_section.navigation.support")))])])]), _vm._v(" "), _vm._m(0)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "divider"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a4639f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-section.vue
// module id = 303
// module chunks = 1